import { type ComponentProps } from 'react';
import clsx from 'clsx';
import { ToggleButton as ReactAriaToggleButton } from 'react-aria-components';
import { Paragraph } from '../../main';
import styles from './ToggleButtonPill.module.css';

type ToggleButtonPillProps = {
  label: string;
  trailingIcon?: React.ReactNode;
  leadingIcon?: React.ReactNode;
} & ComponentProps<typeof ReactAriaToggleButton>;

export function ToggleButtonPill(props: ToggleButtonPillProps) {
  const { className, label, trailingIcon, leadingIcon, ...rest } = props;

  return (
    <ReactAriaToggleButton
      className={clsx(className, styles['toggle-button-pill'])}
      {...rest}
    >
      <Paragraph className={styles['label-container']} variant="body">
        {leadingIcon && (
          <span className={styles['leading-icon']}>{leadingIcon}</span>
        )}

        {label}

        {trailingIcon && (
          <span className={styles['trailing-icon']}>{trailingIcon}</span>
        )}
      </Paragraph>
    </ReactAriaToggleButton>
  );
}
